/* Keep the Shopify cookie banner's policy link inside the selected Store market. */
(() => {
  if (!['sothing.com', 'www.sothing.com'].includes(location.hostname)) return;
  const policy = document.querySelector('.ds-footer a[href*="/policies/privacy-policy"]');
  if (!policy) return;
  const correct = () => {
    const link = document.getElementById('shopify-pc__banner__body-policy-link');
    if (link && link.href !== policy.href) link.href = policy.href;
  };
  correct();
  new MutationObserver(correct).observe(document.body, {childList: true, subtree: true});
})();
